import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const COLOR_PALETTE = [
  "var(--color-blue)",
  "var(--color-green)",
  "var(--color-dark-red)",
  "var(--color-dark-green)",
  "var(--color-electric-blue)",
  "var(--color-orange)",
  "var(--color-pink)",
  "var(--color-violet)",
  "var(--color-dark-brown)",
];

export const getChartData = (surveyAnswer: any) => {
  if (!surveyAnswer?.length) return [];

  const responseCounts: { [key: string]: number } = surveyAnswer.reduce(
    (acc: { [key: string]: number }, answer: any) => {
      const response = answer.content.answer;
      acc[response] = (acc[response] || 0) + 1;
      return acc;
    },
    {}
  );
  const totalResponses = Object.values(responseCounts).reduce((sum, count) => sum + count, 0);

  let chartData = Object.entries(responseCounts).map(([response, count], index) => ({
    response,
    count,
    percentage: ((count / totalResponses) * 100).toFixed(2),
    color: COLOR_PALETTE[index % COLOR_PALETTE.length],
  }));

  chartData = chartData.sort((a, b) => parseFloat(a.response) - parseFloat(b.response));
  return chartData;
};

export const calculateGlobalNote = (chartData: Array<{ response: string; count: number }>) => {
  const totals = chartData.reduce(
    (totals, { response, count }) => {
      const value = parseFloat(response);
      if (!isNaN(value)) {
        totals.sum += value * count;
        totals.count += count;
      }
      return totals;
    },
    { sum: 0, count: 0 }
  );

  return totals.count ? (totals.sum / totals.count).toFixed(2) : null;
};

export const fetchCohortSurveysAnswers = (
  selectedCohortId: number,
  language: string,
  setSurveyAnswer: Function,
  setLoading: Function
) => {
  setLoading(true);
  ApiService.get(`cohorts/${selectedCohortId}/surveys/answers`)
    .then((response) => {
      setSurveyAnswer(response.data.cohort_survey_answers);
    })
    .catch((err) => {
      console.error("An error occurred on fetching cohort's surveys answers", err);
      alert(translate(language, "ERROR.API_ERROR"));
    })
    .finally(() => setLoading(false));
};
